import { get } from './index'

export const list = params => {
  return get('/api/admin_log/list', params)
}

export const listDetail = params => {
  return get('/api/admin_log/desc', params)
}